import React, { useState } from 'react';
import { Tree } from 'antd';
import { Row, Col } from 'antd';
import {
  ButtonContainer,
  SubmitButton,
  StyledLabel,
  RadioButtonsPicker,
  InputContainer,
  SimpleSelectSearch,
} from '../../../../common/form/FormElements.jsx';
import PropTypes from 'prop-types';
import { CollapseBlock, SortItemRenderer } from '../../../../common/index.jsx';
import { withTranslation } from 'react-i18next';
import { BLOCKS_POSITIONS } from '../../../../../utils/constants/enums.js';
import useOnTreeDrop from '../../../../../hooks/useOnTreeDrop.jsx';

const getFilteredBlocks = (allBlocks, currentPosition, usingEnglish) => {
  //Params which are in state in case when state change there could be old value, this is more safe
  const nodes = [];

  allBlocks.map((block) =>
    nodes.push({
      title: usingEnglish ? block.label_en : block.label_sk,
      key: block.id,
      ...block,
    }),
  );

  return nodes
    .filter((node) => {
      if (!usingEnglish && node.position_sk === currentPosition) {
        return !!node.display_sk;
      } else if (usingEnglish && node.position_en === currentPosition) {
        return !!node.display_en;
      } else return false;
    })
    .sort((a, b) => {
      const orderField = usingEnglish ? 'order_en' : 'order_sk';
      if (a[orderField] < b[orderField]) {
        return -1;
      }
      if (a[orderField] > b[orderField]) {
        return 1;
      }
      return 0;
    });
};
const BlocksSortOrder = ({ allBlocks, onOrderSave, t }) => {
  const [openedPosition, changePosition] = useState(
    BLOCKS_POSITIONS.RIGHT_SIDEBAR,
  );
  const [isEnglish, changeLanguage] = useState(false);
  const [treeData, setTreeData] = useState(
    getFilteredBlocks(allBlocks, openedPosition, isEnglish),
  );

  const onDrop = useOnTreeDrop(treeData, (data) => {
    setTreeData(data);
  });

  return (
    <>
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <Row>
            <Col lg={{ span: 12 }} sm={{ span: 24 }}>
              <InputContainer>
                <StyledLabel>{t('Pozícia bloku')}</StyledLabel>
                <SimpleSelectSearch
                  value={openedPosition}
                  options={[
                    { name: t('Spodný panel'), value: BLOCKS_POSITIONS.FOOTER },
                    {
                      name: t('Pravý panel'),
                      value: BLOCKS_POSITIONS.RIGHT_SIDEBAR,
                    },
                  ]}
                  onChange={(newOption) => {
                    const newPosition = newOption.value;
                    changePosition(newPosition);
                    setTreeData(
                      getFilteredBlocks(allBlocks, newPosition, isEnglish),
                    );
                  }}
                />
              </InputContainer>
            </Col>
          </Row>

          <Row>
            <Col lg={{ span: 12 }} sm={{ span: 24 }}>
              <RadioButtonsPicker
                items={[
                  {
                    id: 'slovak',
                    name: 'slovak',
                    label: t('Slovenská verzia'),
                  },
                  {
                    id: 'english',
                    name: 'english',
                    label: t('Anglická verzia'),
                  },
                ]}
                title={t('Verzia blokov pre jazyk')}
                defaultId={isEnglish ? 'english' : 'slovak'}
                onChange={(chosenId) => {
                  const usingEnglish = chosenId === 'english';
                  setTreeData(
                    getFilteredBlocks(allBlocks, openedPosition, usingEnglish),
                  );
                  changeLanguage(usingEnglish);
                }}
              />
            </Col>
          </Row>

          <Tree
            className="draggable-tree"
            draggable
            blockNode
            onDrop={onDrop}
            treeData={treeData}
            allowDrop={({ dropPosition }) => dropPosition > 0} // * - Disabled nesting
            titleRender={(node) => (
              <SortItemRenderer
                title={isEnglish ? node.label_en : node.label_sk}
                block_id={node.id}
                description={node.meta_name}
              />
            )}
          />
        </CollapseBlock>
        <ButtonContainer>
          <SubmitButton
            onClick={() => onOrderSave(treeData, isEnglish)}
            type="button"
            submitKey={'blocks'}
          >
            {t('Uložiť')}
          </SubmitButton>
        </ButtonContainer>
      </div>
    </>
  );
};

BlocksSortOrder.propTypes = {
  allBlocks: PropTypes.array,
  onOrderSave: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(BlocksSortOrder);
